export const formSelector = (state) => state?.form || {};

export const contributeFormSelector = (state) => formSelector(state)?.contribute || null;
export const contributeFormActiveSelector = (state) =>
  contributeFormSelector(state)?.active || null;
